
import { defineComponent, ref, useCssModule } from 'vue'
import Card from '@/components/Card.vue'

declare var app_config : any

export default defineComponent({
	components: {
		Card,
	},
	setup() {
		const loading = ref(false)
		const clickLogin = () => {
			loading.value = true

			const targetURL = new URL('https://www.facebook.com/v19.0/dialog/oauth')
			targetURL.searchParams.append('client_id', app_config.appId)
			targetURL.searchParams.append('redirect_uri', app_config.redirect_uri)
			targetURL.searchParams.append('state', app_config.client_source)
			targetURL.searchParams.append('scope', "public_profile,email")

			window.location.href = targetURL.href
		}

		return {
			style: useCssModule(),
			appConfig: app_config,
			clickLogin,
			loading,
		}
	}
})
